import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { PageHeader } from "@/components/PageHeader";
import { EmptyState } from "@/components/VideoCard";
import { Poster } from "@/components/Poster";
import { api } from "@/lib/api";

export default function Shows() {
  const [q, setQ] = useState("");
  const [shows, setShows] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => api.get("/shows", { params: { q } }).then((r) => setShows(r.data)), 250);
    return () => clearTimeout(t);
  }, [q]);
  return (
    <div>
      <PageHeader eyebrow="Library" title="TV Shows" testid="shows-title" sub={shows ? `${shows.length} shows` : " "}>
        <div className="relative w-full sm:w-72">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search shows…" className="h-10 bg-white pl-9" data-testid="shows-search-input" />
        </div>
      </PageHeader>
      {shows && !shows.length && <EmptyState title="No shows yet" text="Episodes appear here once a Plex TV library is imported." testid="shows-empty" />}
      <div className="grid grid-cols-2 gap-x-5 gap-y-8 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6" data-testid="shows-grid">
        {(shows || []).map((s, i) => (
          <Link key={s.key} to={`/show?key=${encodeURIComponent(s.key)}`} className="group animate-rise" style={{ animationDelay: `${Math.min(i, 20) * 30}ms` }} data-testid={`show-card-${i}`}>
            <div className="relative aspect-[2/3] overflow-hidden rounded-md border border-zinc-200/70 bg-white">
              <Poster id={s.poster_id} alt={s.name} className="h-full w-full transition-transform duration-500 group-hover:scale-[1.04]" />
              <span className="absolute bottom-2 left-2 rounded bg-zinc-900/80 px-1.5 py-0.5 font-mono text-[10px] text-white">{s.episodes} ep</span>
            </div>
            <p className="mt-3 truncate text-sm font-medium">{s.name}</p>
            <p className="truncate font-mono text-[11px] text-zinc-500">{s.seasons.length} {s.seasons.length === 1 ? "season" : "seasons"}{s.year ? ` · ${s.year}` : ""}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
